export const GET_REGIONS_REQUEST = 'regions/GET_REGIONS_REQUEST'
export const GET_REGIONS_SUCCESS = 'regions/GET_REGIONS_SUCCESS'
export const GET_REGIONS_FAILURE = 'regions/GET_REGIONS_FAILURE'